import {
  QUERY_PUBLIC_ACCOUNT_BY_DYNAMICS_ID,
  QUERY_PUBLIC_ACCOUNT_BY_ID,
} from './publicAccountQuery';
import { QUERY_CONTACT } from './contactDataQuery';
import { MUTATION_CREATE_CREDIT_APP } from './createCreditApplication';
import { MUTATION_CREATE_CREDIT_APP_RAW_VALUES } from './createCreditApplicationRawValues';
import { UPSERT_FILE, UPSERT_DOCUMENT } from './upsertFile';
import { QUERY_PARTNER } from './queryPartner';
import { QUERY_PARTNER_LINK } from './queryPartnerLink';
import { QUERY_LENDER_PROFILE_BY_DYNAMICS_ID, QUERY_LENDER_PROFILE_BY_ID } from './lenderProfileQueries';
import { QUERY_TASK, QUERY_ACCOUNT_TASKS_TEMPLATES, UPDATE_TASK_STATUS, UPDATE_TASK, GENERATE_E_SIGN_URL, SAVE_E_SIGN_DOCUMENT, REMOVE_DOCUMENT_TASK_ITEM, REMOVE_ALL_DOCUMENT_TASK_ITEM } from './taskQueries';
import { SEND_SLACK_NOTIFICATION } from './sendSlackNotification';
import { Q_CREDIT_APP, Q_CREDIT_APP_PUBLIC, UPDATE_CREDIT_APPLICATION_V2_QUERY } from './creditApplicationQueries';
import { QUERY_CREDIT_SUBMISSION_PUBLIC } from './creditSubmissionQueries';
import { QUERY_VENDOR_OPPORTUNITY } from './vendorOpportunityQueries';
import getCreditAppStatus from './getCreditAppStatus';
import { apiMapping } from './apiMapping';
import { CREATE_TRACKING_EVENT } from './trackingEvents/createTrackingEvent';


export const trackingEventsApi = {
  createTrackingEvent: CREATE_TRACKING_EVENT,
};

export {
  QUERY_PUBLIC_ACCOUNT_BY_ID,
  QUERY_PUBLIC_ACCOUNT_BY_DYNAMICS_ID,
  QUERY_CONTACT,
  MUTATION_CREATE_CREDIT_APP,
  MUTATION_CREATE_CREDIT_APP_RAW_VALUES,
  UPSERT_FILE,
  UPSERT_DOCUMENT,
  QUERY_PARTNER,
  QUERY_PARTNER_LINK,
  QUERY_LENDER_PROFILE_BY_DYNAMICS_ID,
  QUERY_LENDER_PROFILE_BY_ID,
  QUERY_TASK,
  QUERY_ACCOUNT_TASKS_TEMPLATES,
  UPDATE_TASK_STATUS,
  UPDATE_TASK,
  GENERATE_E_SIGN_URL,
  SAVE_E_SIGN_DOCUMENT,
  REMOVE_DOCUMENT_TASK_ITEM,
  REMOVE_ALL_DOCUMENT_TASK_ITEM,
  SEND_SLACK_NOTIFICATION,
  Q_CREDIT_APP,
  Q_CREDIT_APP_PUBLIC,
  UPDATE_CREDIT_APPLICATION_V2_QUERY,
  QUERY_CREDIT_SUBMISSION_PUBLIC,
  QUERY_VENDOR_OPPORTUNITY,
  getCreditAppStatus,
  apiMapping,
};
